

const storage = {
    code_verifier: "code_verifier",
    access_token: "access_token",
    refresh_token: "refresh_token",
    code: "code",
    user: "user",
    hr9Clinic: "hr9Clinic",
    profile: "profile",
    isguest: "isguest",
    company_uuid: "company_uuid",
    profile_mysa: "profile_mysa"
};

export default {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: 5000000,
    ...storage
};